import classNames from 'classnames'
import formatDuration from 'lib/format-duration'
import React from 'react'

const playIcon = require('static/play-icon-light.png')

export default function SquareDuration({
  duration,
  className,
}: {
  duration: string | number | undefined
  className?: string
}) {
  return (
    <span className={classNames(className, 'square-duration')}>
      <img src={playIcon} />
      {duration && (
        <span className="duration">
          {typeof duration === 'string' ? duration : formatDuration(duration)}
        </span>
      )}

      <style jsx>
        {`
          .square-duration {
            width: 51px;
            height: 18px;
            border-radius: 2px;
            display: flex;
            align-items: center;
            background-color: rgba(0, 0, 0, 0.5);
            padding: 0 6px;
          }
          img {
            width: 12px;
            height: 12px;
            object-fit: cover;
            object-position: center;
            margin-right: 2px;
          }

          .duration {
            font-size: 12px;
            transform: scale(0.833);
            transform-origin: left center;
            line-height: 1.4;
            color: #ffffff;
          }
        `}
      </style>
    </span>
  )
}
